<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">The Magic Toy Shop</h1>
<ol class="toc">
<li id="toc-li-1">
<a href="#/text/ch001#about-the-author">About the Author</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#dedication">Dedication</a>
</li>
<li id="toc-li-3">
<a href="#/text/ch003#copyright-information">Copyright Information©</a>
</li>
<li id="toc-li-4">
<a href="#/text/ch004#chapter-1-the-enchanted-village">Chapter 1: The Enchanted Village</a>
</li>
<li id="toc-li-5">
<span href="#/text/ch005#chapter-2-the-village-toy-shop" title="Link target outside of Sample">Chapter 2: The Village Toy Shop</span>
</li>
<li id="toc-li-6">
<span href="#/text/ch006#chapter-3-the-magic-comes-alive" title="Link target outside of Sample">Chapter 3: The Magic Comes Alive</span>
</li>
<li id="toc-li-7">
<span href="#/text/ch007#chapter-4-a-name-and-a-new-friend" title="Link target outside of Sample">Chapter 4: A Name and a New Friend</span>
</li>
<li id="toc-li-8">
<span href="#/text/ch008#chapter-5-a-winter-crisis" title="Link target outside of Sample">Chapter 5: A Winter Crisis</span>
</li>
<li id="toc-li-9">
<span href="#/text/ch009#chapter-6-the-magic-of-christmas" title="Link target outside of Sample">Chapter 6: The Magic of Christmas</span>
</li>
<li id="toc-li-10">
<span href="#/text/ch010#chapter-7-maisies-terrible-boxing-day" title="Link target outside of Sample">Chapter 7: Maisie’s Terrible Boxing Day</span>
</li>
<li id="toc-li-11">
<span href="#/text/ch011#chapter-8-a-decision-to-sell-the-shop" title="Link target outside of Sample">Chapter 8: A Decision to Sell the Shop
          </span>
</li>
<li id="toc-li-12">
<span href="#/text/ch012#chapter-9-the-birthday-party" title="Link target outside of Sample">Chapter 9: The Birthday Party</span>
</li>
<li id="toc-li-13">
<span href="#/text/ch013#chapter-10-maisie-gets-her-dad-back" title="Link target outside of Sample">Chapter 10: Maisie Gets Her Dad Back</span>
</li>
<li id="toc-li-14">
<span href="#/text/ch014#chapter-11-a-troublesome-addition-to-the-family" title="Link target outside of Sample">Chapter 11: A Troublesome Addition to the Family</span>
</li>
<li id="toc-li-15">
<span href="#/text/ch015#chapter-12-maisie-has-an-insecure-moment" title="Link target outside of Sample">Chapter 12: Maisie Has an Insecure Moment</span>
</li>
<li id="toc-li-16">
<span href="#/text/ch016#chapter-13-a-magical-touch-of-kindness" title="Link target outside of Sample">Chapter 13: A Magical Touch of Kindness</span>
</li>
<li id="toc-li-17">
<span href="#/text/ch017#chapter-14-mums-and-daughters-friendship-grows" title="Link target outside of Sample">Chapter 14: Mum’s and Daughter’s Friendship Grows</span>
</li>
<li id="toc-li-18">
<span href="#/text/ch018#chapter-15-martha-believes-she-is-different" title="Link target outside of Sample">Chapter 15: Martha Believes She is Different</span>
</li>
<li id="toc-li-19">
<span href="#/text/ch019#chapter-16-the-toy-robot-mystery" title="Link target outside of Sample">Chapter 16: The Toy Robot Mystery
          </span>
</li>
<li id="toc-li-20">
<span href="#/text/ch020#chapter-17-revenge-is-so-sweet-for-maisie" title="Link target outside of Sample">Chapter 17: Revenge is so Sweet for Maisie</span>
</li>
<li id="toc-li-21">
<span href="#/text/ch021#chapter-18-a-school-project-stirs-it-all-up-again" title="Link target outside of Sample">Chapter 18: A School Project Stirs it all up Again</span>
</li>
<li id="toc-li-22">
<span href="#/text/ch022#chapter-19-the-school-loses-its-favourite-maths-teacher" title="Link target outside of Sample">Chapter 19: The School Loses its Favourite Maths Teacher</span>
</li>
<li id="toc-li-23">
<span href="#/text/ch023#chapter-20-a-lively-village-loses-its-personality" title="Link target outside of Sample">Chapter 20: A Lively Village Loses its Personality</span>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?64f6b9b4